export default __webpack_public_path__ + "static/fb-share-default-93139db0a938d97880fe285748324c8c.jpg";